export const hoverable = (style: TemplateStringsArray | string) => `
  @media (hover: hover) {
    ${style};
  }
`;
